module.exports = __webpack_public_path__ + "img/content12.19f77791.png";